export class DailyActiveUsersMonthlyUsage {
  botName!: string;
  botId!: string;
  total!: number;

  constructor(dailyActiveUsersMonthlyUsage: Partial<DailyActiveUsersMonthlyUsage>) {
    Object.assign(this, dailyActiveUsersMonthlyUsage);
  }
}
